'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var searchContext = {
    none: { id: 0, value: 'none', description: 'None' },
    seller: { id: 1, value: 'seller', description: 'Seller' },
    discount: { id: 2, value: 'discount', description: 'Discount' },
    brand: { id: 3, value: 'brand', description: 'Brand' },
    category: { id: 4, value: 'category', description: 'Category' },
    search: { id: 5, value: 'search', description: 'Search' },
    sellerProducts: {
        id: 6,
        value: 'sellerProducts',
        description: 'SellerProducts'
    }
};

var newsContext = {
    main: { id: 0, value: 'main', description: 'main' },
    seller: { id: 1, value: 'seller', description: 'seller' },
    brand: { id: 2, value: 'brand', description: 'brand' },
    product: { id: 3, value: 'product', description: 'product' }
};

// all values in categoryType are those that are in table CategoryType
var categoryType = {
    apbCategory: { id: 1, value: 'apbCategory', description: 'APB Category' },
    category: { id: 2, value: 'category', description: 'Category' },
    brand: { id: 3, value: 'brand', description: 'Brand' },
    seller: { id: 45, value: 'seller', description: 'Seller' },
    productRange: { id: 47, value: 'productRange', description: 'ProductRange' }
};

// other category types are those that are not in CategoryType, but that are categories/blocks in the filter
var otherCategoryType = {
    discountType: {
        id: 101,
        value: 'discountType',
        description: 'Discount type'
    },
    seller: { id: 102, value: 'sellers', description: 'Sellers' },
    discountsOnly: {
        id: 103,
        value: 'discountsOnly',
        description: 'Discounts only'
    }
};

// the different type of filters.
// these are stored in different tables in the database, but are passed in the same array when getting the filters
// we keep these values to distinguish between different types
var categoryFilterType = {
    category: { id: 0, description: 'Category' },
    sellerCategory: { id: 1, description: 'Seller category' },
    seller: { id: 2, description: 'Seller' },
    discountType: { id: 3, description: 'discountType' },
    customCategory: { id: 10, value: 'specialDiscounts', description: 'Special Discounts' }
};

var navigationMenuItems = {
    home: { id: 1, value: 'home' },
    discounts: { id: 2, value: 'discounts' },
    sellers: { id: 3, value: 'sellers' },
    brands: { id: 4, value: 'brands' },
    products: { id: 5, value: 'products' },
    news: { id: 6, value: 'news' }
};

var productContexts = {
    PRODUCTDETAIL: 'PRODUCTDETAIL'
};

var getAmounts = {
    default: 20
};

var orderStatusTexts = {
    REGSELLER: { text: gettext('Registered by seller') },
    CREATED: { text: gettext('Created') },
    SENTSELLER: { text: gettext('Sent to seller') },
    REGWS: { text: gettext('Registered') },
    BUSYWS: { text: gettext('In progress') },
    READYWS: { text: gettext('(Will be) delivered') },
    CANCELLED: { text: gettext('Cancelled') },
    ERROR: { text: gettext('Error') },
    REGWSP: { text: gettext('Partially registered by wholesaler') },
    BUSYWSP: { text: gettext('Partially in progress by wholesaler') },
    READYWSP: { text: gettext('(Will be) partially delivered') },
    INVWS: { text: gettext('Invoiced') },
    INVWSP: { text: gettext('Partially invoiced') }
};

var deliveryStatusTexts = {
    DELIVREG: { text: gettext('Registered') },
    DELIVBUSY: { text: gettext('In progress') },
    DELIVREADY: { text: gettext('(Will be) delivered') },
    DELIVINV: { text: gettext('Delivered') }
};

var bannerTextAlignmentClasses = {
    '0': { name: '' },
    '1': { name: 'hero-text-top-left' },
    '2': { name: 'hero-text-top-center' },
    '3': { name: 'hero-text-top-right' },
    '4': { name: 'hero-text-left' },
    '5': { name: 'hero-text-center' },
    '6': { name: 'hero-text-right' },
    '7': { name: 'hero-text-bottom-left' },
    '8': { name: 'hero-text-bottom-center' },
    '9': { name: 'hero-text-bottom-right' }
};

var emailLanguages = [{
    id: 2,
    displayName: gettext('Dutch')
}, {
    id: 3,
    displayName: gettext('French')
}];

var orderProductStatusCodes = {
    CREATED: { value: 'CREATED' },
    CONFIRMED: { value: 'CONFIRMED' },
    ERROR: { value: 'ERROR' },
    REPLACED: { value: 'REPLACED' },
    MODIFIED: { value: 'MODIFIED' },
    CANCELLED: { value: 'CANCELLED' },
    REQUESTED: { value: 'REQUESTED' },
    REG: { value: 'REG' },
    PEN: { value: 'PEN' },
    CON: { value: 'CON' },
    CWN: { value: 'CWN' },
    CAN: { value: 'CAN' }
};

var orderProductReasonCodes = {
    NOSTOCK: { value: 'NOSTOCK' },
    NOSTOCKSUP: { value: 'NOSTOCKSUP' },
    UNKCNK: { value: 'UNKCNK' },
    OFFMARKET: { value: 'OFFMARKET' },
    NOSERVICE: { value: 'NOSERVICE' },
    REFUSED: { value: 'REFUSED' },
    FORWARDED: { value: 'FORWARDED' },
    LIMITED: { value: 'LIMITED' },
    CUSTSERV: { value: 'CUSTSERV' }
};

var rentalProductRelationTypeCodes = {
    RECOM: { value: 'RECOM' },
    INTER: { value: 'INTER' }
};

var newsSliderSettings = {
    dots: true,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    touchMove: false,
    responsive: [{
        breakpoint: 1199,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 3
        }
    }, {
        breakpoint: 991,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2
        }
    }, {
        breakpoint: 767,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2
        }
    }, {
        breakpoint: 575,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }]
};

var partnershipGallerySliderSettings = {
    autoplay: false,
    dots: true,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    infinite: false,
    variableWidth: false,
    responsive: [{
        breakpoint: 992,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 3
        }
    }, {
        breakpoint: 576,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2
        }
    }]
};

var productSliderSettings = {
    dots: true,
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    touchMove: false,
    responsive: [{
        breakpoint: 1199,
        settings: {
            slidesToShow: 4,
            slidesToScroll: 4
        }
    }, {
        breakpoint: 991,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 3
        }
    }, {
        breakpoint: 767,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2
        }
    }, {
        breakpoint: 575,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }]
};

var rentalCheckoutMenuSteps = exports.rentalCheckoutMenuSteps = [{ index: 0, value: 'Uw aanvraag' }, { index: 1, value: 'Suggesties' }, { index: 2, value: 'Verstuur' }];

var enums = exports.enums = {
    bannerTextAlignmentClasses: bannerTextAlignmentClasses,
    searchContext: searchContext,
    newsContext: newsContext,
    categoryType: categoryType,
    otherCategoryType: otherCategoryType,
    categoryFilterType: categoryFilterType,
    navigationMenuItems: navigationMenuItems,
    orderStatusTexts: orderStatusTexts,
    deliveryStatusTexts: deliveryStatusTexts,
    productContexts: productContexts,
    emailLanguages: emailLanguages,
    orderProductStatusCodes: orderProductStatusCodes,
    orderProductReasonCodes: orderProductReasonCodes,
    getAmounts: getAmounts,
    partnershipGallerySliderSettings: partnershipGallerySliderSettings,
    productSliderSettings: productSliderSettings,
    newsSliderSettings: newsSliderSettings,
    rentalCheckoutMenuSteps: rentalCheckoutMenuSteps,
    rentalProductRelationTypeCodes: rentalProductRelationTypeCodes
};

var breakpoints = exports.breakpoints = [{ name: 'xs', min: 0, max: 575 }, { name: 'sm', min: 576, max: 767 }, { name: 'md', min: 768, max: 991 }, { name: 'lg', min: 992, max: 1199 }, { name: 'xl', min: 1200, max: 99999 }];

var productTypes = exports.productTypes = {
    single: { serverValue: 'PORTALPRODUCT', clientValue: 'single' },
    pack: { serverValue: 'PROMOPACK', clientValue: 'pack' },
    panacee: { serverValue: 'PANACEE', clientValue: 'panacee' }
};

var discountTypes = exports.discountTypes = {
    single: { serverValue: 'PORTALPRODUCT', clientValue: 'single' },
    pack: { serverValue: 'PROMOPACK', clientValue: 'pack' },
    panacee: { serverValue: 'PANACEE', clientValue: 'panacee' },
    counter: { serverValue: 'PRODUCTCOUNTER', clientValue: 'counter' }
};

var discountTypeNames = exports.discountTypeNames = {
    PORTALPRODUCT: {
        serverValue: 'PORTALPRODUCT',
        clientValue: gettext('Product discount')
    },
    PROMOPACK: { serverValue: 'PROMOPACK', clientValue: gettext('Promopack') },
    PANACEE: { serverValue: 'PANACEE', clientValue: gettext('Panaché') },
    PRODUCTCOUNTER: {
        serverValue: 'PRODUCTCOUNTER',
        clientValue: gettext('Counter discount')
    },
    ORDERTOTALPRICE: {
        serverValue: 'ORDERTOTALPRICE', clientValue: gettext('Order total price')
    }
};

var cartMessageTypes = exports.cartMessageTypes = {
    info: { serverValue: 0, clientValue: 'info' },
    warning: { serverValue: 1, clientValue: 'warning' },
    disabled: { serverValue: 2, clientValue: 'disabled' },
    error: { serverValue: 3, clientValue: 'error' }
};

var sortProperties = exports.sortProperties = {
    DiscountDate: {
        value: 'DiscountDate',
        displayname: gettext('Discount date'),
        defaultSorting: 'desc'
    },
    DiscountAmount: {
        value: 'DiscountAmount',
        displayname: gettext('Max. discount'),
        defaultSorting: 'desc'
    },
    UnitPrice: {
        value: 'UnitPrice',
        displayname: gettext('Price'),
        defaultSorting: 'asc'
    },
    Name: {
        value: 'Name',
        displayname: gettext('Name'),
        defaultSorting: 'asc'
    },
    ProductNumber: { value: 'ProductNumber', displayname: gettext('ProductNumber'), defaultSorting: 'asc' },
    Bwm: { value: 'Bwm', displayname: gettext('GPM'), defaultSorting: 'asc' },
    ProductCreationDate: {
        value: 'ProductCreationDate',
        displayname: gettext('Newest'),
        defaultSorting: 'desc'
    }
};

var newsTypes = exports.newsTypes = [{
    type: 'product',
    label: 'Product'
}, {
    type: 'company',
    label: 'Bedrijf'
}, {
    type: 'campaign',
    label: 'Campagne'
}, {
    type: 'training',
    label: 'Opleiding'
}, {
    type: 'event',
    label: 'Event'
}];

function gettext(string) {
    return string;
}


//////////////////
// WEBPACK FOOTER
// ./common/core/enums.js
// module id = 701
// module chunks = 0